import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { Icon } from 'loyal-react'

const redirectGoBack = (history, referer) => {
  if (referer || window.location.pathname.indexOf('products') > 0) {
    history.push('/')
  } else {
    history.goBack()
  }
}

const BackButtonMobile = ({ history, refererIsLogin }) => {
  return (
    <div className='d-block d-md-none'>
      {(window.location.pathname.indexOf('confirmation') === 0 || window.location.pathname.substring(window.location.pathname.lastIndexOf('/')) !== '/') && (
        <button
          className='h-100 btn-back-page-mobile btn-back-page btn-sm btn btn-flat btn-icon btn-icon-only back-page'
          aria-label='Voltar'
          onClick={() => redirectGoBack(history, refererIsLogin)}
        >
          <Icon
            className='icon color-brand-5'
            iconName='icon_left_app'
          />
          <span className='d-none'>Voltar </span>
        </button>
      )}
    </div>
  )
}

BackButtonMobile.propTypes = {
  history: PropTypes.object,
  refererIsLogin: PropTypes.bool
}
export default withRouter(BackButtonMobile)



// WEBPACK FOOTER //
// ./src/App/Header/BackButton/BackButtonMobile.js